import React from 'react';
import { toAbsoluteUrl } from '../../utils';
import clsx from 'clsx';

import './SearchInputSmall.scss';

interface ISearchInputProps {
	placeholder: string;
	searchValue?: string;
	additionalClass?: string;
	setSearchValue?: (value: string) => void;
	isDisabled?: boolean;
	isGreyBG?: boolean;
	setIsRefreshed?: (value: boolean) => void,
	inputRef?: any;
	showError?: boolean;
	errorMessage?: string;
	cypressAttribute?: string;
}

export const SearchInputSmall = (props: ISearchInputProps): JSX.Element => {
	const {
		placeholder, additionalClass, searchValue,
		setSearchValue, isDisabled, isGreyBG, setIsRefreshed,
		inputRef, showError, errorMessage, cypressAttribute = ''
	} = props;

	const handleChange = (e):void => {
		setSearchValue(e.target.value);
		if (setIsRefreshed !== undefined) {
			setIsRefreshed(false);
		}
	};

	return (
		<div className={clsx(
			'fc-search-input-container rounded-2',
				additionalClass && additionalClass,
				isGreyBG ? 'grey-bg' : 'bg-white'
			)}
			data-cy={cypressAttribute}
		>
			<input
				type="text"
				placeholder={placeholder}
				className={clsx(
					'form-control form-control-sm form-control-solid input-placeholder border-0 fc-search-input-width',
					!isGreyBG && 'bg-transparent'
				)}
				onChange={handleChange}
				disabled={isDisabled}
				value={searchValue}
				ref={inputRef}
			/>
			<img
				src={toAbsoluteUrl('/media/icons/search.svg')}
				className="fc-search-input-icon"
				alt="search"
			/>
			{showError && (
				<div className="error-container search-error-position">
					<div className="text-danger fs-8">{errorMessage}</div>
				</div>
			)}
		</div>
	);
};
